<!-- =========================================================================================
  File Name: TheNavbarVertical.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div>
  <div class="relative">
               
    <div class="vx-navbar-wrapper" :class="classObj">
          <!-- <top-alert /> -->
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />
        <!-- <feather-icon icon="StarIcon" :svgClasses="['stoke-current text-warning']" class="cursor-pointer p-2"  /> -->
        <h4 class="text-dark vx-logo-text"
              v-if="topBarTitle">{{ topBarTitle }}</h4>
        <vs-spacer />
         <new-message-notification/>
        <requsted-incident-notification/>
        <pending-user-notification/>


        <!-- <notification-drop-down /> -->

        <profile-drop-down />

      </vs-navbar>
    </div>
            <top-alert />

  </div>
  </div>
</template>


<script>
import Bookmarks            from './components/Bookmarks.vue'
import SearchBar            from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import PendingUserNotification from './components/PendingUsersNotification.vue'
import RequstedIncidentNotification from './components/RequstedIncidentNotification.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import TopAlert from './components/TopAlert.vue'
import NewMessageNotification from './components/NewMessageNotification.vue'


export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    PendingUserNotification,
    RequstedIncidentNotification,
    ProfileDropDown,
    TopAlert,
    NewMessageNotification
   
  },
  computed: {
    topBarTitle () {
      return this.$store.state.topBarTitle
    },
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>

